const isAllowedFeature = require('module/user/helpers/is_allowed_feature')
const log = require('log').create('isAllowedSpotlight') // eslint-disable-line

module.exports = function isAllowedSpotlight(user, spotlight) {
    // anyone can see non-premium spotlights
    if (! spotlight.is_premium) return true

    return isAllowedFeature(user, 'pro_spotlights')
}
